import React from 'react'
import XPModal from '../../../../components/xp-modal'
import './index.less'
interface ModalPropsRule {
    text: string | any
    onConfirm: () => void
    onCancel: () => void
    cancelText?: string
    confirmText?: string
    withoutCancel?: boolean
    visible: boolean
    title?: string
}
const SharingMessageModal = (props: ModalPropsRule) => {
    const { text, onCancel, onConfirm, cancelText, confirmText, visible, withoutCancel = false, title } = props
    return visible
        ?
        <XPModal
            cls={{
                modal: 'sharing-message-modal'
            }}
        >
            <div className='message-modal-container'>
                {!!title && <div className='message-modal-title'>{title}</div>}
                <div className={`text-container ${title ? '' : 'container-without-title'}`}>{text}</div>
                <div className='btn-group'>
                    {
                        !withoutCancel
                        &&
                        <div
                            className='cancel'
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                onCancel()
                            }}>
                            {cancelText || '取消'}
                        </div>
                    }
                    <div
                        className='confirm'
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            onConfirm()
                        }}>
                        {confirmText || '确定'}
                    </div>
                </div>
            </div>
        </XPModal>
        : null
}

export default SharingMessageModal